<template>
<div class="section">
  <div v-if="contentType == 'Markdown'" v-bind:is="transformed" v-bind="$props" class="md"/>
  <app-image v-if="contentType == 'Image'" class="img" :src="content.url" :metadata="content.meta"/>
</div>
</template>

<script>
import {marked} from 'marked'
import AppImage from './AppImage'
export default {
  components: {AppImage},
  props: ['content'],
  data: () => {
    return {
      image_height: '400px'
    }
  },
  computed: {
    transformed() {
      return {
        template: this.transformer(),
        props: this.$options.props
      }
    },
    contentType() {
      return this.content.type
    }
  },
  methods: {
    transformer() {
      let content = this.content.data || ""
      return "<div>" + marked(content, { renderer: this.renderer }) + "</div>"
    }
  },
  created() {
    this.renderer = new marked.Renderer()
    this.renderer.link = function(href, title, text){
      const link_prefix = href.split(':')[0]
      if(link_prefix == 'https' || link_prefix == 'http'){
        return `<a href="${href}" target="_blank">${text}</a>`
      } else {
        return `<router-link to="${href}">${text}</router-link>`
      }
    }
    marked.setOptions({
      renderer: this.renderer,
      gfm: false,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false
    })
  }
}
</script>
